const RoleList = () => import("@/pages/auth/role/index.vue");
const RoleForm = () => import("@/pages/auth/role/form.vue");

export default [
  {
    path: "/auth/role",
    component: RoleList,
    meta: [
      {
        name: "权限管理",
		activeRoute: '/auth/manage'
      },
      {
        name: "角色管理",
        activeRoute: "/auth/role",
      },
    ],
  },
  {
    path: "/auth/role/form",
    component: RoleForm,
    meta: [
      {
        name: "权限管理",
		activeRoute: '/auth/manage'
      },
      {
        name: "角色管理",
        url: "/auth/role",
      },
      {
        name: "新增/编辑",
        activeRoute: "/auth/role",
      },
    ],
  },
];
